import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=3671a9a6&scoped=true"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"
import style0 from "./Tip.vue?vue&type=style&index=0&id=3671a9a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671a9a6",
  null
  
)

export default component.exports